import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["tabindex"];
var _hoisted_2 = ["innerHTML"];
import { watch, ref, nextTick } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectItem',
  props: {
    label: {
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    idx: {
      default: -1
    }
  },
  emits: ["click", "mouseover"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var liItem = ref(null);
    watch(() => props.active, curState => {
      if (curState) {
        nextTick(() => {
          var _a;
          (_a = liItem.value) === null || _a === void 0 ? void 0 : _a.focus();
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _a;
      return _openBlock(), _createElementBlock("li", {
        ref_key: "liItem",
        ref: liItem,
        class: _normalizeClass(["tw-text-w-black", [{
          'tw-bg-w-cultured active': _ctx.active
        }, 'tw-outline-none', _ctx.$attrs['class']]]),
        tabindex: (_a = _ctx.$attrs['tabindex']) !== null && _a !== void 0 ? _a : -1,
        onClick: _cache[0] || (_cache[0] = $event => emits('click', props.idx)),
        onMouseover: _cache[1] || (_cache[1] = $event => emits('mouseover', props.idx))
      }, [_renderSlot(_ctx.$slots, "default", {
        itemIdx: _ctx.idx
      }, () => [_createElementVNode("span", {
        innerHTML: props.label
      }, null, 8 /* PROPS */, _hoisted_2)])], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1);
    };
  }
});